module.exports = __webpack_public_path__ + "static/img/5.f365f8fc.jpg";